function buildMap(mapBlock) {
    const canvas = mapBlock.querySelector('[data-map-canvas]');
    if (!canvas || !window.google || !window.google.maps) return;

    let parsedMarkers = [];
    try {
        parsedMarkers = JSON.parse(mapBlock.dataset.markers || '[]');
    } catch (error) {
        parsedMarkers = [];
    }

    const markers = parsedMarkers
        .map((item) => ({
            lat: parseFloat(item?.lat),
            lng: parseFloat(item?.lng),
            title: typeof item?.title === 'string' ? item.title.trim() : '',
            address: typeof item?.address === 'string' ? item.address.trim() : '',
        }))
        .filter((item) => !Number.isNaN(item.lat) && !Number.isNaN(item.lng));

    const datasetCenterLat = parseFloat(mapBlock.dataset.centerLat || '');
    const datasetCenterLng = parseFloat(mapBlock.dataset.centerLng || '');
    const hasDatasetCenter = !Number.isNaN(datasetCenterLat) && !Number.isNaN(datasetCenterLng);
    const firstMarker = markers[0] || null;
    const centerLat = hasDatasetCenter ? datasetCenterLat : (firstMarker ? firstMarker.lat : 51.509865);
    const centerLng = hasDatasetCenter ? datasetCenterLng : (firstMarker ? firstMarker.lng : -0.118092);
    const hasExplicitZoom = !!mapBlock.dataset.zoom;
    const zoom = parseInt(mapBlock.dataset.zoom || '7', 10);

    const map = new google.maps.Map(canvas, {
        center: { lat: centerLat, lng: centerLng },
        zoom,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        styles: [
            { elementType: 'geometry', stylers: [{ color: '#e5e5e5' }] },
            { elementType: 'labels.text.fill', stylers: [{ color: '#6b6b6b' }] },
            { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f5f5' }] },
            { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#c9c9c9' }] },
            { featureType: 'poi', stylers: [{ visibility: 'off' }] },
            { featureType: 'road', elementType: 'labels', stylers: [{ visibility: 'off' }] },
            { featureType: 'road', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
            { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#ffffff' }] },
            { featureType: 'road', elementType: 'geometry.stroke', stylers: [{ color: '#d0d0d0' }] },
        ],
    });

    const pinSvg = `
        <svg width="47" height="59" viewBox="0 0 47 59" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M23.3333 29.1667C24.9375 29.1667 26.3108 28.5955 27.4531 27.4531C28.5955 26.3108 29.1667 24.9375 29.1667 23.3333C29.1667 21.7292 28.5955 20.3559 27.4531 19.2135C26.3108 18.0712 24.9375 17.5 23.3333 17.5C21.7292 17.5 20.3559 18.0712 19.2135 19.2135C18.0712 20.3559 17.5 21.7292 17.5 23.3333C17.5 24.9375 18.0712 26.3108 19.2135 27.4531C20.3559 28.5955 21.7292 29.1667 23.3333 29.1667ZM23.3333 58.3333C15.5069 51.6736 9.66146 45.4878 5.79688 39.776C1.93229 34.0642 0 28.7778 0 23.9167C0 16.625 2.34549 10.816 7.03646 6.48958C11.7274 2.16319 17.1597 0 23.3333 0C29.5069 0 34.9392 2.16319 39.6302 6.48958C44.3212 10.816 46.6667 16.625 46.6667 23.9167C46.6667 28.7778 44.7344 34.0642 40.8698 39.776C37.0052 45.4878 31.1597 51.6736 23.3333 58.3333Z" fill="#FF8CFD"/>
        </svg>
    `;
    const pinIcon = {
        url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(pinSvg),
        scaledSize: new google.maps.Size(36, 48),
        anchor: new google.maps.Point(18, 48),
    };

    const escapeHtml = (value) => value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

    class InfoOverlay extends google.maps.OverlayView {
        constructor(position, html) {
            super();
            this.position = position;
            this.html = html;
            this.container = null;
        }

        onAdd() {
            this.container = document.createElement('div');
            this.container.className = 'map-info-window map-info-window--hidden';
            this.container.innerHTML = this.html;

            this.container.addEventListener('click', (event) => {
                event.stopPropagation();
            });

            const closeButton = this.container.querySelector('[data-map-info-close]');
            if (closeButton) {
                closeButton.addEventListener('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    this.hide();
                });
            }

            this.getPanes().floatPane.appendChild(this.container);
        }

        draw() {
            if (!this.container) return;
            const projection = this.getProjection();
            if (!projection) return;
            const point = projection.fromLatLngToDivPixel(this.position);
            if (!point) return;

            this.container.style.left = `${point.x}px`;
            this.container.style.top = `${point.y}px`;

            const isDesktop = window.matchMedia('(min-width: 992px)').matches;
            this.container.classList.toggle('map-info-window--desktop', isDesktop);
        }

        onRemove() {
            if (this.container && this.container.parentNode) {
                this.container.parentNode.removeChild(this.container);
            }
            this.container = null;
        }

        show() {
            if (this.container) this.container.classList.remove('map-info-window--hidden');
        }

        hide() {
            if (this.container) this.container.classList.add('map-info-window--hidden');
        }
    }

    let openOverlay = null;
    const closeCurrentOverlay = () => {
        if (openOverlay) {
            openOverlay.hide();
            openOverlay = null;
        }
    };

    const markersToRender = markers.length ? markers : [{ lat: centerLat, lng: centerLng, title: '', address: '' }];
    const bounds = new google.maps.LatLngBounds();

    markersToRender.forEach((item) => {
        const position = { lat: item.lat, lng: item.lng };
        bounds.extend(position);
        const markerLabel = item.title || item.address || 'Map marker';

        const marker = new google.maps.Marker({
            map,
            position,
            icon: pinIcon,
            title: markerLabel,
        });

        const title = item.title;
        const addressLines = item.address
            ? item.address.split(',').map((line) => line.trim()).filter(Boolean)
            : [];
        const hasInfo = !!title || addressLines.length > 0;

        if (!hasInfo) {
            return;
        }

        const contentHtml = [
            '<div class="map-info-window__panel">',
            '<button class="map-info-window__close" type="button" aria-label="Close" data-map-info-close>&times;</button>',
            title ? `<h6 class="map-info-window__title">${escapeHtml(title)}</h6>` : '',
            addressLines.length
                ? `<div class="body-small map-info-window__address">${addressLines.map((line) => escapeHtml(line)).join('<br>')}</div>`
                : '',
            '</div>',
        ].join('');

        const overlay = new InfoOverlay(new google.maps.LatLng(item.lat, item.lng), contentHtml);
        overlay.setMap(map);

        marker.addListener('click', () => {
            if (openOverlay === overlay) {
                closeCurrentOverlay();
                return;
            }

            closeCurrentOverlay();
            overlay.draw();
            overlay.show();
            openOverlay = overlay;
        });
    });

    if (markersToRender.length > 1 && !hasExplicitZoom) {
        map.fitBounds(bounds);
    }

    map.addListener('click', closeCurrentOverlay);
    window.addEventListener('resize', () => {
        if (openOverlay) openOverlay.draw();
    });
}

function initMaps() {
    document.querySelectorAll('[data-map]').forEach(buildMap);
}

window.initMaps = initMaps;
